export default "__VITE_ASSET__CmBJffz1__"